module.exports = __webpack_public_path__ + "static/media/QualityControl-Banner@2x.8b44de15.jpg";